"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var flickity_1 = __importDefault(require("flickity"));
var CustomFlickityNavigation_1 = __importDefault(require("../../helpers/CustomFlickityNavigation"));
var debounce_1 = __importDefault(require("../../utilities/debounce"));
exports.default = (function () {
    var specialLayout = document.querySelector('.CallToAction--specialLayout');
    if (specialLayout) {
        var card_1 = specialLayout.querySelector('.Card');
        var WIDTH_CONSTANT_1 = .3245;
        specialLayout.style.marginBottom = '0';
        var debounceResize = debounce_1.default(function () {
            var elementHeight = specialLayout.getBoundingClientRect().height;
            var cardHeight = card_1.getBoundingClientRect().height;
            var overlap = (window.innerWidth * WIDTH_CONSTANT_1) - elementHeight;
            var calculatedHeight = elementHeight + cardHeight - Math.abs(overlap);
            specialLayout.style.height = calculatedHeight + 'px';
        }, 250);
        debounceResize();
        window.addEventListener('resize', debounceResize);
    }
    if (!document.querySelector('.CtaPageLinks__container[data-slider]'))
        return;
    var previousBtn = document.querySelector('.CtaPageLinks__nav .previous');
    var nextBtn = document.querySelector('.CtaPageLinks__nav .next');
    var flkty = new flickity_1.default('.CtaPageLinks__container[data-slider]', {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.15,
        friction: 0.8
    });
    if (nextBtn && previousBtn) {
        CustomFlickityNavigation_1.default(flkty, previousBtn, nextBtn);
    }
});
